import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContentCheckLink } from "apis/checkPageFacebook";
import { RootState } from "store";
import { checkPageState, IResponseCheckLink } from "./type";

export const initialState: checkPageState = {
  is_checking_page: false,
  check_result: undefined,
};

const checkPageSlice = createSlice({
  name: "checkPage",
  initialState,
  reducers: {
    checkingPageStarted(state, action: PayloadAction<IContentCheckLink>) {
      state.is_checking_page = true;
      state.error = undefined;
    },
    checkingPagesSuccess(state, action: PayloadAction<IResponseCheckLink>) {
      state.is_checking_page = false;
      state.check_result = action.payload;
    },
    checkingPageFailed(state, action: PayloadAction<checkPageState["error"]>) {
      state.is_checking_page = false;
      state.error = action.payload;
    },
  },
});

export const checkPageActions = checkPageSlice.actions;

export const selectCheckPageLoading = (state: RootState) =>
  state.checkPage.is_checking_page;

export const selectCheckResult = (state: RootState) =>
  state.checkPage.check_result;

const checkPageReducer = checkPageSlice.reducer;
export default checkPageReducer;
